import {
  consultationDurations,
  consultationPurposes,
  consultationTimezones
} from '../../assets/consultationOptions';
import { FormField } from './FormField';

export function StepMeetingSchedule({ register, errors }) {
  return (
    <div className="booking-step">
      <div className="booking-step__intro">
        <p className="eyebrow">Step 3</p>
        <h3>Meeting Schedule</h3>
        <p>Pick a time that works — we will confirm availability after review.</p>
      </div>

      <div className="booking-grid">
        <FormField id="timezone" label="Timezone" required error={errors.timezone?.message}>
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('timezone')}
            >
              <option value="">Select timezone</option>
              {consultationTimezones.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField id="preferredDate" label="Preferred Date" required error={errors.preferredDate?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="date"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('preferredDate')}
            />
          )}
        </FormField>

        <FormField id="preferredTime" label="Preferred Time" required error={errors.preferredTime?.message}>
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="time"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('preferredTime')}
            />
          )}
        </FormField>

        <FormField
          id="meetingDuration"
          label="Meeting Duration"
          required
          error={errors.meetingDuration?.message}
        >
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('meetingDuration')}
            >
              {consultationDurations.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField
          id="meetingPurpose"
          label="Meeting Purpose"
          required
          className="booking-field--full"
          error={errors.meetingPurpose?.message}
        >
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('meetingPurpose')}
            >
              {consultationPurposes.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>
      </div>
    </div>
  );
}
